/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const updateReportSubscription = /* GraphQL */ `mutation UpdateReportSubscription($reportId: String!, $subscribe: Boolean!) {
  updateReportSubscription(reportId: $reportId, subscribe: $subscribe) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportSubscriptionMutationVariables,
  APITypes.UpdateReportSubscriptionMutation
>;
export const updateBoughtListOptOut = /* GraphQL */ `mutation UpdateBoughtListOptOut($id: ID!, $optOut: Boolean!) {
  updateBoughtListOptOut(id: $id, optOut: $optOut) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoughtListOptOutMutationVariables,
  APITypes.UpdateBoughtListOptOutMutation
>;
export const createBLConcurrencyLock = /* GraphQL */ `mutation CreateBLConcurrencyLock(
  $input: CreateBLConcurrencyLockInput!
  $condition: ModelBLConcurrencyLockConditionInput
) {
  createBLConcurrencyLock(input: $input, condition: $condition) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBLConcurrencyLockMutationVariables,
  APITypes.CreateBLConcurrencyLockMutation
>;
export const updateBLConcurrencyLock = /* GraphQL */ `mutation UpdateBLConcurrencyLock(
  $input: UpdateBLConcurrencyLockInput!
  $condition: ModelBLConcurrencyLockConditionInput
) {
  updateBLConcurrencyLock(input: $input, condition: $condition) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBLConcurrencyLockMutationVariables,
  APITypes.UpdateBLConcurrencyLockMutation
>;
export const deleteBLConcurrencyLock = /* GraphQL */ `mutation DeleteBLConcurrencyLock(
  $input: DeleteBLConcurrencyLockInput!
  $condition: ModelBLConcurrencyLockConditionInput
) {
  deleteBLConcurrencyLock(input: $input, condition: $condition) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBLConcurrencyLockMutationVariables,
  APITypes.DeleteBLConcurrencyLockMutation
>;
export const createBoughtList = /* GraphQL */ `mutation CreateBoughtList(
  $input: CreateBoughtListInput!
  $condition: ModelBoughtListConditionInput
) {
  createBoughtList(input: $input, condition: $condition) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBoughtListMutationVariables,
  APITypes.CreateBoughtListMutation
>;
export const updateBoughtList = /* GraphQL */ `mutation UpdateBoughtList(
  $input: UpdateBoughtListInput!
  $condition: ModelBoughtListConditionInput
) {
  updateBoughtList(input: $input, condition: $condition) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoughtListMutationVariables,
  APITypes.UpdateBoughtListMutation
>;
export const deleteBoughtList = /* GraphQL */ `mutation DeleteBoughtList(
  $input: DeleteBoughtListInput!
  $condition: ModelBoughtListConditionInput
) {
  deleteBoughtList(input: $input, condition: $condition) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBoughtListMutationVariables,
  APITypes.DeleteBoughtListMutation
>;
export const createUserFilter = /* GraphQL */ `mutation CreateUserFilter(
  $input: CreateUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  createUserFilter(input: $input, condition: $condition) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserFilterMutationVariables,
  APITypes.CreateUserFilterMutation
>;
export const updateUserFilter = /* GraphQL */ `mutation UpdateUserFilter(
  $input: UpdateUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  updateUserFilter(input: $input, condition: $condition) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserFilterMutationVariables,
  APITypes.UpdateUserFilterMutation
>;
export const deleteUserFilter = /* GraphQL */ `mutation DeleteUserFilter(
  $input: DeleteUserFilterInput!
  $condition: ModelUserFilterConditionInput
) {
  deleteUserFilter(input: $input, condition: $condition) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserFilterMutationVariables,
  APITypes.DeleteUserFilterMutation
>;
export const createExportJob = /* GraphQL */ `mutation CreateExportJob(
  $input: CreateExportJobInput!
  $condition: ModelExportJobConditionInput
) {
  createExportJob(input: $input, condition: $condition) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExportJobMutationVariables,
  APITypes.CreateExportJobMutation
>;
export const updateExportJob = /* GraphQL */ `mutation UpdateExportJob(
  $input: UpdateExportJobInput!
  $condition: ModelExportJobConditionInput
) {
  updateExportJob(input: $input, condition: $condition) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExportJobMutationVariables,
  APITypes.UpdateExportJobMutation
>;
export const deleteExportJob = /* GraphQL */ `mutation DeleteExportJob(
  $input: DeleteExportJobInput!
  $condition: ModelExportJobConditionInput
) {
  deleteExportJob(input: $input, condition: $condition) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExportJobMutationVariables,
  APITypes.DeleteExportJobMutation
>;
export const createReportRunSchedule = /* GraphQL */ `mutation CreateReportRunSchedule(
  $input: CreateReportRunScheduleInput!
  $condition: ModelReportRunScheduleConditionInput
) {
  createReportRunSchedule(input: $input, condition: $condition) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportRunScheduleMutationVariables,
  APITypes.CreateReportRunScheduleMutation
>;
export const updateReportRunSchedule = /* GraphQL */ `mutation UpdateReportRunSchedule(
  $input: UpdateReportRunScheduleInput!
  $condition: ModelReportRunScheduleConditionInput
) {
  updateReportRunSchedule(input: $input, condition: $condition) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportRunScheduleMutationVariables,
  APITypes.UpdateReportRunScheduleMutation
>;
export const deleteReportRunSchedule = /* GraphQL */ `mutation DeleteReportRunSchedule(
  $input: DeleteReportRunScheduleInput!
  $condition: ModelReportRunScheduleConditionInput
) {
  deleteReportRunSchedule(input: $input, condition: $condition) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportRunScheduleMutationVariables,
  APITypes.DeleteReportRunScheduleMutation
>;
export const createHouselistNew = /* GraphQL */ `mutation CreateHouselistNew(
  $input: CreateHouselistNewInput!
  $condition: ModelHouselistNewConditionInput
) {
  createHouselistNew(input: $input, condition: $condition) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    priorityType
    nextStep
    salesCounselor
    timeframe
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHouselistNewMutationVariables,
  APITypes.CreateHouselistNewMutation
>;
export const updateHouselistNew = /* GraphQL */ `mutation UpdateHouselistNew(
  $input: UpdateHouselistNewInput!
  $condition: ModelHouselistNewConditionInput
) {
  updateHouselistNew(input: $input, condition: $condition) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    priorityType
    nextStep
    salesCounselor
    timeframe
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHouselistNewMutationVariables,
  APITypes.UpdateHouselistNewMutation
>;
export const deleteHouselistNew = /* GraphQL */ `mutation DeleteHouselistNew(
  $input: DeleteHouselistNewInput!
  $condition: ModelHouselistNewConditionInput
) {
  deleteHouselistNew(input: $input, condition: $condition) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    priorityType
    nextStep
    salesCounselor
    timeframe
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHouselistNewMutationVariables,
  APITypes.DeleteHouselistNewMutation
>;
export const createAccount = /* GraphQL */ `mutation CreateAccount(
  $input: CreateAccountInput!
  $condition: ModelAccountConditionInput
) {
  createAccount(input: $input, condition: $condition) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountMutationVariables,
  APITypes.CreateAccountMutation
>;
export const updateAccount = /* GraphQL */ `mutation UpdateAccount(
  $input: UpdateAccountInput!
  $condition: ModelAccountConditionInput
) {
  updateAccount(input: $input, condition: $condition) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountMutationVariables,
  APITypes.UpdateAccountMutation
>;
export const deleteAccount = /* GraphQL */ `mutation DeleteAccount(
  $input: DeleteAccountInput!
  $condition: ModelAccountConditionInput
) {
  deleteAccount(input: $input, condition: $condition) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountMutationVariables,
  APITypes.DeleteAccountMutation
>;
export const createContact = /* GraphQL */ `mutation CreateContact(
  $input: CreateContactInput!
  $condition: ModelContactConditionInput
) {
  createContact(input: $input, condition: $condition) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContactMutationVariables,
  APITypes.CreateContactMutation
>;
export const updateContact = /* GraphQL */ `mutation UpdateContact(
  $input: UpdateContactInput!
  $condition: ModelContactConditionInput
) {
  updateContact(input: $input, condition: $condition) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContactMutationVariables,
  APITypes.UpdateContactMutation
>;
export const deleteContact = /* GraphQL */ `mutation DeleteContact(
  $input: DeleteContactInput!
  $condition: ModelContactConditionInput
) {
  deleteContact(input: $input, condition: $condition) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContactMutationVariables,
  APITypes.DeleteContactMutation
>;
export const createSalesOption = /* GraphQL */ `mutation CreateSalesOption(
  $input: CreateSalesOptionInput!
  $condition: ModelSalesOptionConditionInput
) {
  createSalesOption(input: $input, condition: $condition) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSalesOptionMutationVariables,
  APITypes.CreateSalesOptionMutation
>;
export const updateSalesOption = /* GraphQL */ `mutation UpdateSalesOption(
  $input: UpdateSalesOptionInput!
  $condition: ModelSalesOptionConditionInput
) {
  updateSalesOption(input: $input, condition: $condition) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSalesOptionMutationVariables,
  APITypes.UpdateSalesOptionMutation
>;
export const deleteSalesOption = /* GraphQL */ `mutation DeleteSalesOption(
  $input: DeleteSalesOptionInput!
  $condition: ModelSalesOptionConditionInput
) {
  deleteSalesOption(input: $input, condition: $condition) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSalesOptionMutationVariables,
  APITypes.DeleteSalesOptionMutation
>;
export const createStaffSeed = /* GraphQL */ `mutation CreateStaffSeed(
  $input: CreateStaffSeedInput!
  $condition: ModelStaffSeedConditionInput
) {
  createStaffSeed(input: $input, condition: $condition) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStaffSeedMutationVariables,
  APITypes.CreateStaffSeedMutation
>;
export const updateStaffSeed = /* GraphQL */ `mutation UpdateStaffSeed(
  $input: UpdateStaffSeedInput!
  $condition: ModelStaffSeedConditionInput
) {
  updateStaffSeed(input: $input, condition: $condition) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStaffSeedMutationVariables,
  APITypes.UpdateStaffSeedMutation
>;
export const deleteStaffSeed = /* GraphQL */ `mutation DeleteStaffSeed(
  $input: DeleteStaffSeedInput!
  $condition: ModelStaffSeedConditionInput
) {
  deleteStaffSeed(input: $input, condition: $condition) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStaffSeedMutationVariables,
  APITypes.DeleteStaffSeedMutation
>;
export const createDistanceToSite = /* GraphQL */ `mutation CreateDistanceToSite(
  $input: CreateDistanceToSiteInput!
  $condition: ModelDistanceToSiteConditionInput
) {
  createDistanceToSite(input: $input, condition: $condition) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDistanceToSiteMutationVariables,
  APITypes.CreateDistanceToSiteMutation
>;
export const updateDistanceToSite = /* GraphQL */ `mutation UpdateDistanceToSite(
  $input: UpdateDistanceToSiteInput!
  $condition: ModelDistanceToSiteConditionInput
) {
  updateDistanceToSite(input: $input, condition: $condition) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDistanceToSiteMutationVariables,
  APITypes.UpdateDistanceToSiteMutation
>;
export const deleteDistanceToSite = /* GraphQL */ `mutation DeleteDistanceToSite(
  $input: DeleteDistanceToSiteInput!
  $condition: ModelDistanceToSiteConditionInput
) {
  deleteDistanceToSite(input: $input, condition: $condition) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDistanceToSiteMutationVariables,
  APITypes.DeleteDistanceToSiteMutation
>;
export const createFilterValue = /* GraphQL */ `mutation CreateFilterValue(
  $input: CreateFilterValueInput!
  $condition: ModelFilterValueConditionInput
) {
  createFilterValue(input: $input, condition: $condition) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFilterValueMutationVariables,
  APITypes.CreateFilterValueMutation
>;
export const updateFilterValue = /* GraphQL */ `mutation UpdateFilterValue(
  $input: UpdateFilterValueInput!
  $condition: ModelFilterValueConditionInput
) {
  updateFilterValue(input: $input, condition: $condition) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFilterValueMutationVariables,
  APITypes.UpdateFilterValueMutation
>;
export const deleteFilterValue = /* GraphQL */ `mutation DeleteFilterValue(
  $input: DeleteFilterValueInput!
  $condition: ModelFilterValueConditionInput
) {
  deleteFilterValue(input: $input, condition: $condition) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFilterValueMutationVariables,
  APITypes.DeleteFilterValueMutation
>;
export const createFlagDefinition = /* GraphQL */ `mutation CreateFlagDefinition(
  $input: CreateFlagDefinitionInput!
  $condition: ModelFlagDefinitionConditionInput
) {
  createFlagDefinition(input: $input, condition: $condition) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlagDefinitionMutationVariables,
  APITypes.CreateFlagDefinitionMutation
>;
export const updateFlagDefinition = /* GraphQL */ `mutation UpdateFlagDefinition(
  $input: UpdateFlagDefinitionInput!
  $condition: ModelFlagDefinitionConditionInput
) {
  updateFlagDefinition(input: $input, condition: $condition) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlagDefinitionMutationVariables,
  APITypes.UpdateFlagDefinitionMutation
>;
export const deleteFlagDefinition = /* GraphQL */ `mutation DeleteFlagDefinition(
  $input: DeleteFlagDefinitionInput!
  $condition: ModelFlagDefinitionConditionInput
) {
  deleteFlagDefinition(input: $input, condition: $condition) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlagDefinitionMutationVariables,
  APITypes.DeleteFlagDefinitionMutation
>;
export const createDataTransferStage = /* GraphQL */ `mutation CreateDataTransferStage(
  $input: CreateDataTransferStageInput!
  $condition: ModelDataTransferStageConditionInput
) {
  createDataTransferStage(input: $input, condition: $condition) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDataTransferStageMutationVariables,
  APITypes.CreateDataTransferStageMutation
>;
export const updateDataTransferStage = /* GraphQL */ `mutation UpdateDataTransferStage(
  $input: UpdateDataTransferStageInput!
  $condition: ModelDataTransferStageConditionInput
) {
  updateDataTransferStage(input: $input, condition: $condition) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDataTransferStageMutationVariables,
  APITypes.UpdateDataTransferStageMutation
>;
export const deleteDataTransferStage = /* GraphQL */ `mutation DeleteDataTransferStage(
  $input: DeleteDataTransferStageInput!
  $condition: ModelDataTransferStageConditionInput
) {
  deleteDataTransferStage(input: $input, condition: $condition) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDataTransferStageMutationVariables,
  APITypes.DeleteDataTransferStageMutation
>;
export const createExclusionRule = /* GraphQL */ `mutation CreateExclusionRule(
  $input: CreateExclusionRuleInput!
  $condition: ModelExclusionRuleConditionInput
) {
  createExclusionRule(input: $input, condition: $condition) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExclusionRuleMutationVariables,
  APITypes.CreateExclusionRuleMutation
>;
export const updateExclusionRule = /* GraphQL */ `mutation UpdateExclusionRule(
  $input: UpdateExclusionRuleInput!
  $condition: ModelExclusionRuleConditionInput
) {
  updateExclusionRule(input: $input, condition: $condition) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExclusionRuleMutationVariables,
  APITypes.UpdateExclusionRuleMutation
>;
export const deleteExclusionRule = /* GraphQL */ `mutation DeleteExclusionRule(
  $input: DeleteExclusionRuleInput!
  $condition: ModelExclusionRuleConditionInput
) {
  deleteExclusionRule(input: $input, condition: $condition) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExclusionRuleMutationVariables,
  APITypes.DeleteExclusionRuleMutation
>;
export const invokeFileManagerLambda = /* GraphQL */ `mutation InvokeFileManagerLambda($input: AWSJSON!) {
  invokeFileManagerLambda(input: $input)
}
` as GeneratedMutation<
  APITypes.InvokeFileManagerLambdaMutationVariables,
  APITypes.InvokeFileManagerLambdaMutation
>;
